<template>
  <llp-page
    id="datatable-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="row bbps-row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <h4 class="service m-4">Products Activated</h4>
          <div v-if="loading" class="loader-container">
            <div class="spinner"></div>
          </div>
          <div class="row m-4">
            <div
              class="col-lg-4 col-md-6 col-sm-8 mb-4"
              v-for="service in services"
              :key="service.id"
            >
              <div class="service-item">
                <div class="d-flex align-items-center mb-5">
                  <i
                    :class="service.icon_name"
                    aria-hidden="true"
                    class="ms-4 fs-3 service-icon"
                  ></i>
                  <span class="ms-4 fs-5">{{ service.name }}</span>
                </div>
                <h6 class="ms-4 text-start description">
                  {{ service.description }}
                </h6>

                <div class="d-flex justify-content-end p-2">
                  <llp-button
                    classNames="btn-secondary text-white access-btn new-btn"
                    @click="accessServices(service.name, service.id)"
                    >Access</llp-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import NetworkService from "@/services/network.service";
import ErrorService from "../../../services/error.service";
import router from "@/router";
export default {
  data() {
    return {
      loading: true,
      service: [],
    };
  },
  mounted() {
    this.fetchServices();
  },
  methods: {
    async fetchServices() {
      try {
        const response = await NetworkService.get("services");
        this.services = response.services;
        this.loading = false;
      } catch (error) {
        console.error("Error fetching services:", error);
        this.loading = false;
        if (error.message) {
          this.$refs.toast.show("Unable to loding the services", "error");
        } else {
          this.$refs.toast.show(ErrorService.getErrorMessages(error), "error");
        }
      }
    },
    //  makeUrlFriendly(serviceName) {
    //   return serviceName.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();
    // },

    makeUrlFriendly(serviceName) {
      return serviceName
        .replace(/\s+/g, "-")
        .replace(/[^a-zA-Z0-9-]/g, "")
        .replace(/-+/g, "-")
        .toLowerCase();
    },

    async accessServices(name, id) {
      try {
        const transformedName = this.makeUrlFriendly(name);
        if (transformedName == "loans-emi") {
          this.$router.push({
            name: "service-category",
            params: { serviceId: id, category_id: id },
          });
        } else if (transformedName == "education-fee-payments") {
          this.$router.push({
            name: "EducationFee",
            params: { serviceId: id },
          });
        } else if (transformedName == "vendors-payments") {
          this.$router.push({
            name: "VendorPayment",
            params: { serviceId: id },
          });
          // this.$router.push("/vendor-payments");
        } else if (transformedName == "rental-payments") {
          this.$router.push({
            name: "RentPayment",
            params: { serviceId: id },
          });
        } else if (transformedName == "donations-payments") {
          this.$router.push({
            name: "DonationPayments",
            params: { serviceId: id },
          });
        } else if (transformedName == "salary-payments") {
          this.$router.push({
            name: "SalaryPayment",
            params: { serviceId: id },
          });
        } else if (transformedName == "ca-related-payments") {
          this.$router.push({
            name: "CaRelatedPayment",
            params: { serviceId: id },
          });
          // this.$router.push("/ca-related-payments");
        } else if (transformedName == "legal-services-fee") {
          this.$router.push({
            name: "LegalServiceFee",
            params: { serviceId: id },
          });
        } else if (transformedName == "fees-by-credit-card") {
          this.$router.push({
            name: "CreditCardPayments",
            params: { serviceId: id },
          });
        } else {
          router.push({
            name: "ServiceDetails",
            params: { serviceName: transformedName, serviceId: id },
          });
        }
      } catch (error) {
        this.$refs.toast.show(
          "An error occurred while navigating service.",
          "error"
        );
      }
    },
  },
};
</script>


